<template>
    <span>
        <template v-if="typeof showMode != 'undefined' && showMode === 'text' ">
            <template v-if="field.code && field.options && field.options.length > 0">
                {{getCodeOptionsValue(field, bean)}}
            </template>
            <template v-else>
                <template v-if="typeof field.classCode != 'undefined' && field.classCode === true">
                    {{translateClassCodeName(field, bean)}}
                </template>
                <template v-else-if="field.widgetType === Constants.DataDic.WidgetType.YesOrNo">
                    {{translateYesOrNo(field, bean)}}
                </template>
                <template v-else>
                    {{bean[fieldName || field.name]}}
                </template>
            </template>
        </template>
        <template v-else>
            <!-- switch(是否)-->
            <el-switch v-if="field.widgetType === Constants.DataDic.WidgetType.YesOrNo" :size="size" :disabled="disabled ||  field.disabled" v-model="bean[fieldName || field.name]" active-text="是" inactive-text="否" active-value="true" inactive-value="false" />
            <!-- input -->
            <el-input v-if="field.widgetType === 'SingleLineText'" :size="size" :disabled="disabled ||  field.disabled" v-model="bean[fieldName || field.name]" :placeholder="field.label" :maxlength="field.maxLength" :minlength="field.minLength" />
            <!-- 手机号 -->
            <el-input v-if="field.widgetType === 'MobileNumber'" :size="size" :disabled="disabled ||  field.disabled" type="tel" v-model="bean[fieldName || field.name]" :placeholder="field.label" :maxlength="field.maxLength" :minlength="field.minLength" />
            <!-- Number -->
            <el-input v-if="field.widgetType === 'Number'" :size="size" :disabled="disabled ||  field.disabled" type="number" v-model="bean[fieldName || field.name]" :placeholder="field.label" :maxlength="field.maxLength" :minlength="field.minLength" />
            <!-- textarea -->
            <el-input v-else-if="field.widgetType ==='MultiLineText'" :size="size" :disabled="disabled ||  field.disabled" type="textarea" :rows="3" :placeholder="field.label" v-model="bean[fieldName || field.name]" />
            <!-- Radio -->
            <el-radio-group v-else-if="field.widgetType ==='Radio' " :size="size" :disabled="disabled ||  field.disabled" v-model="bean[fieldName || field.name]">
                <el-radio v-for="o in field.options" :label="typeof o.value == 'undefined' ? o.id : o.value " :key="o.name">{{o.name}}</el-radio>
            </el-radio-group>
            <!-- select -->
            <el-select v-else-if="field.widgetType === 'DropdownSelect' " :size="size" :disabled="disabled ||  field.disabled" v-model="bean[fieldName || field.name]" :placeholder="field.label" :clearable="true" style="width:100%" @change="(val) => onDropdownChanged(field, val)">
                <el-option v-for="o in field.options" :key="o.id" :label="o.name" :value="typeof o.value == 'undefined' ? o.id : o.value"></el-option>
            </el-select>
            <el-cascader v-else-if="field.classCode && field.widgetType === Constants.DataDic.WidgetType.Cascader" :placeholder="field.label" :size="size" v-model="cascaderVal" :options="field.options" :props="{multiple: field.multiple, label: 'name', value: 'code' }" clearable style="width:100%" @change="onChangeCascader"></el-cascader>
            <!-- Date -->
            <el-date-picker v-else-if="field.widgetType === 'Date' " :size="size" :disabled="disabled ||  field.disabled" v-model="bean[fieldName || field.name]" type="date" :placeholder="field.label"></el-date-picker>
            <!-- DateTime -->
            <el-date-picker v-else-if="field.widgetType === 'DateTime' " :size="size" :disabled="disabled ||  field.disabled" v-model="bean[fieldName || field.name]" type="datetime" :placeholder="field.label"></el-date-picker>
            <!-- Time -->
            <el-time-picker v-else-if="field.widgetType === 'Time' " :size="size" :disabled="disabled ||  field.disabled" v-model="bean[fieldName || field.name]" :placeholder="field.label"></el-time-picker>
            <template v-if="field.widgetType === 'CheckBox'">
                <el-checkbox-group v-model="bean[fieldName || field.name]">
                    <el-checkbox v-for="item in field.options" :key="item.id" :label="'' + item.value">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </template>
            <template v-if="field.widgetType == 'PICK_LOCATION' ">
                <div>
                    <el-link type="primary" href="http://api.map.baidu.com/lbsapi/getpoint/index.html" target="_blank">点击这里打开百度地图坐标拾取器</el-link>
                    <el-input :size="size" :disabled="disabled ||  field.disabled" v-model="bean[fieldName || field.name]" placeholder="复制百度选取的坐标填入这里" :maxlength="field.maxLength" :minlength="field.minLength" />
                </div>
            </template>
            <!-- 文件上传，限制最多6个 -->
            <el-upload v-else-if="field.widgetType === 'UploadFile' " :size="size" :disabled="disabled ||  field.disabled" action="/api/storage/resources/upload" multiple :limit="6" :file-list="resoveUploadKey(bean[fieldName || field.name])" :on-success="(res,file)=>handleAvatarSuccess(res,file,field.name,true)">
                <el-button size="mini" type="primary">点击上传</el-button>
            </el-upload>
            <!-- 单个图片上传 -->
            <el-upload class="avatar-uploader" v-else-if="field.widgetType === 'SingleImageUpload' " :size="size" :disabled="disabled ||  field.disabled" action="/api/storage/resources/upload" :show-file-list="false" :with-credentials="true" :on-success="(res,file)=>handleAvatarSuccess(res,file,field.name)" :style="field.style">
                <img v-if="bean[fieldName || field.name]" :src="bean[fieldName || field.name]" style="max-width:100%" :style="field.style" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!-- 多张图片上传，最多6张 -->
            <el-upload v-else-if="field.widgetType === 'MultiImageUpload' " :size="size" :disabled="disabled ||  field.disabled" action="/api/storage/resources/upload" list-type="picture-card" :limit="6" :on-success="(res,file)=>handleAvatarSuccess(res,file,field.name,true)" :file-list="resoveUploadKey(fieldName || field.name )" :on-remove="((file, filelist) => onRemoveOneFromMultiImageUpload(file, filelist, fieldName || field.name) )">
                <i class="el-icon-plus"></i>
            </el-upload>

            <yushu-area :bean="bean" v-else-if="field.widgetType === 'Area' " @onAreaChanged="onAreaChanged" style="width:100%"></yushu-area>

            <!-- 富文本编辑 -->
            <template v-else-if="field.widgetType === 'RichTextEditor' " :disabled="disabled ||  field.disabled">
                <div :id="'ckeditor_' + (this.fieldName || this.field.name)"></div>
            </template>
            <el-alert :show-icon="true" :closable="false" class="form-item-tips" v-if="field.inputTips && field.inputTips.length > 0">{{field.inputTips}}</el-alert>
        </template>
    </span>
</template>
<script>
export default {
    props: ['field', 'bean', 'showMode', 'fieldName', "size", "disabled", "showLastName"],
    data() {
        return {
            fieldKey: this.Utils.uuid(),
            cascaderVal: []
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initCKEditors();
            this.initCheckbox();
            this.initCascader();        // 初始化cascade
            this.initMultiImages();
        });
    },
    watch: {
        'bean'(val) {
            if (val) {
                this.$nextTick(() => {
                    this.initCKEditors();
                    this.initCheckbox();
                });
            }
        }
    },
    methods: {
        initCheckbox() {
            if (this.field) {
                if (this.field.widgetType === 'CheckBox') {
                    if (this.bean[this.fieldName || this.field.name]) {
                        this.bean[this.fieldName || this.field.name] = JSON.parse(this.bean[this.fieldName || this.field.name]) || [];
                    } else {
                        this.bean[this.fieldName || this.field.name] = [];
                    }
                }
            }
        },
        initCascader() {
            if (this.field && this.field.widgetType === Constants.DataDic.WidgetType.Cascader) {
                this.cascaderVal = this.Utils.findPath(this.field.options, 'code', this.bean[this.fieldName || this.field.name]);
            }
        },
        initMultiImages(){
            // 处理多图
            if (this.field && this.field.widgetType === Constants.DataDic.WidgetType.MultiImageUpload) {
                this.images
            }
        },
        getCodeOptionsValue(field, row) {
            for (let i = 0; i < field.options.length; i++) {
                if (field.options[i].value == new String(row[this.fieldName || field.name])) {
                    return field.options[i].name;
                } else if ((field.options[i].value == '1' && row[this.fieldName || field.name] === true) || (field.options[i].value == '0' && row[this.fieldName || field.name] === false)) {
                    return field.options[i].name;
                }
            }
            return '';
        },
        handleAvatarSuccess(res, file, name, isArray) {
            // let url = this.Constants.FileManager.preview(res.data.id);
            let url = res.data.url;
            if (!isArray) {
                Vue.set(this.bean, name, url);
            } else {
                let tempArr = this.bean[name];
                if (!tempArr) {
                    tempArr = [url];
                } else if (typeof tempArr == "string") {
                    tempArr = tempArr.split(";");
                    tempArr.push(url);
                } else {
                    tempArr.push(url);
                }
                Vue.set(this.bean, name, tempArr);
            }
        },
        initCKEditors() {
            if (this.field) {
                if (this.field.widgetType === 'RichTextEditor') {
                    let _fieldName = this.fieldName || this.field.name;
                    this.Utils.initCKEditorField('ckeditor_' + _fieldName, this.bean[this.fieldName || this.field.name] || '');
                }
            }
        },
        translateClassCodeName(field, bean) {
            let value = bean[field.name];
            if (value && value.length > 0) {
                value = JSON.parse(value);
            } else {
                value = [];
            }

            let selectedObj = [];
            if (value.length > 0) {
                value.forEach(item => {
                    this.Utils.recursive(field.options, 'children', (obj) => {
                        if (obj.code == item) {
                            selectedObj.push(obj);
                        }
                    })
                });
            }
            let names = selectedObj.map(item => item.name);
            if (this.showLastName) {
                return names[names.length - 1];
            } else {
                return names.join('/');
            }
        },
        translateYesOrNo(field, bean) {
            let value = bean[field.name];
            if (!value)
                return "否";
            else if (value === 'true' || value === true || value === 1 || value == '1')
                return "是";
            else
                return "否";

        },
        onAreaChanged(val) {
            Vue.set(this.bean, 'areaProvince', val.provinceCode);
            Vue.set(this.bean, 'areaProvinceName', val.provinceName);
            Vue.set(this.bean, 'areaCity', val.cityCode);
            Vue.set(this.bean, 'areaCityName', val.cityName);
            Vue.set(this.bean, 'areaDistrict', val.regionCode);
            Vue.set(this.bean, 'areaDistrictName', val.regionName);
        },
        onChangeCascader(val) {
            if (val) {
                if (val.length == 0) {
                    Vue.set(this.bean, this.fieldName || this.field.name, '');
                } else {
                    Vue.set(this.bean, this.fieldName || this.field.name, val[val.length - 1]);
                }
            }
        },
        onDropdownChanged(field, val) {
            if (field.isOptions && field.optionsFromTable && field.optionsFromTable.length > 0 && field.options && field.options.length > 0) {
                let found = this.Utils.filterArray(field.options, 'id', val);
                if (found && found.length > 0) {
                    let fieldName = fieldName || field.name;
                    let index = fieldName.indexOf('Id');
                    if (index > 0) {
                        fieldName = fieldName.substring(0, index)
                    }
                    this.bean[fieldName + 'Name'] = found[0].name;
                }
            }
        },
        resoveUploadKey(name) {
            if (!this.bean[name]) {
                return [];
            } else if (typeof this.bean[name]) {
                let imageLists = this.bean[name];
                
                if (imageLists && imageLists.length > 0 ) {
                    // 转换为 el-upload 支持的格式
                    imageLists = imageLists.map((url, index) => ({
                        name: `image-${index}.jpg`,
                        url: url,
                        uid: -index - 1 // 使用负数作为唯一标识符，避免与上传的新文件冲突
                    }));
                }
                return imageLists;
            } else {
                return this.bean[name];
            }
        },
        onRemoveOneFromMultiImageUpload(file, fileList, fieldname){
            if (this.bean[fieldname] && file && file.url && file.url.length > 0){
                let idx = this.bean[fieldname].indexOf(file.url);
                if (idx != -1) {
                    this.bean[fieldname].splice(idx, 1);
                }
            }
            console.log(this.bean[fieldname]);
        }
    }
}
</script>